"use client";

import { c as _c } from "react/compiler-runtime";
import { Sparkles } from "lucide-react";
import { motion } from "motion/react";
import { ChatPricingPlans } from "@/components/pricing/chat-pricing-plans";
type StudioNoun = "images" | "videos" | "audio";
interface ChatPlanUpsellProps {
  noun: StudioNoun;
  isAuthenticated: boolean;
  /** When true the user already has a plan but ran out of cycle credits. */
  subscribed?: boolean;
}
const HEADLINE: Record<StudioNoun, string> = {
  images: "Become a member to keep generating images",
  videos: "Become a member to keep generating videos",
  audio: "Become a member to keep generating audio"
};
export function ChatPlanUpsell(t0) {
  const $ = _c(18);
  const {
    noun,
    isAuthenticated,
    subscribed: t1
  } = t0;
  const subscribed = t1 === undefined ? false : t1;
  const headline = subscribed ? "You've used this cycle's credits \u2014 upgrade to keep going" : HEADLINE[noun];
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div aria-hidden={true} className="pointer-events-none absolute inset-x-0 -top-8 mx-auto h-64 max-w-3xl rounded-full opacity-70 blur-3xl" style={{
      background: "radial-gradient(60% 60% at 50% 40%, color-mix(in oklab, var(--foreground) 9%, transparent), transparent 70%)"
    }} />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0,
      y: 16
    };
    t4 = {
      opacity: 1,
      y: 0
    };
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      duration: 0.5,
      ease: [0.16, 1, 0.3, 1]
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="mb-4 inline-flex items-center gap-1.5 rounded-full border border-lounge-gold/30 bg-lounge-gold/[0.07] px-3 py-1 text-xs font-medium text-lounge-gold"><Sparkles className="h-3.5 w-3.5" />The Lounge — every frontier model, one membership</div>;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== headline) {
    t7 = <h2 className="mx-auto max-w-2xl text-balance font-display text-3xl font-semibold leading-tight tracking-tight sm:text-4xl">{headline}</h2>;
    $[5] = headline;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="mx-auto mt-3 max-w-xl text-pretty text-sm leading-relaxed text-muted-foreground sm:text-base">Fast models plus the image, video and audio studios from $9 — or add Claude Opus, GPT-5, Gemini and Grok with Plus and Pro. More usage than you pay for, and a 7-day money-back guarantee.</p>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t7) {
    t9 = <motion.div initial={t3} animate={t4} transition={t5} className="relative mb-9 text-center">{t6}{t7}{t8}</motion.div>;
    $[8] = t7;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      opacity: 0,
      y: 24
    };
    t11 = {
      opacity: 1,
      y: 0
    };
    $[10] = t10;
    $[11] = t11;
  } else {
    t10 = $[10];
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      duration: 0.5,
      ease: [0.16, 1, 0.3, 1],
      delay: 0.08
    };
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== isAuthenticated) {
    t13 = <motion.div initial={t10} animate={t11} transition={t12}><ChatPricingPlans isAuthenticated={isAuthenticated} viewSource="paywall" /></motion.div>;
    $[13] = isAuthenticated;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== t13 || $[16] !== t9) {
    t14 = <div className="relative mx-auto w-full max-w-5xl px-4 py-10 sm:py-14">{t2}{t9}{t13}</div>;
    $[15] = t13;
    $[16] = t9;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  return t14;
}